import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import AdminLogin from './components/Auth/AdminLogin';
import AdminDashboard from './components/Dashboard/AdminDashboard';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import './App.css';

// Custom theme for white & gold admin interface
const theme = {
  token: {
    colorPrimary: '#D4AF37', // Gold
    colorSuccess: '#28A745',
    colorWarning: '#FFC107',
    colorError: '#DC3545',
    colorBgContainer: '#FFFFFF',
    colorBgLayout: '#FFFEF7',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
};

// Protected Route component for admin-only access
function ProtectedRoute({ children }) {
  const { user, isAdmin, loading } = useAuth();
  
  if (loading) {
    return <div>Loading...</div>;
  }
  
  if (!user || !isAdmin) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
}

function App() {
  return (
    <ConfigProvider theme={theme}>
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/login" element={<AdminLogin />} />
              <Route 
                path="/dashboard/*" 
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                } 
              />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
